import { apiClient } from '@/libs/api'

export type DcsWeightDisplaySettingQuery = {
  tenantKey: string
  dcId: number
}

export const fetchWeightDisplaySetting = async (
  { tenantKey, dcId }: DcsWeightDisplaySettingQuery,
  signal?: AbortSignal
) => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .dcs._id(dcId)
    .weight_display_setting.$get({
      config: {
        signal
      }
    })
  return data
}
